import { competitiveIntelligenceResearchTranslations } from './competitive-intelligence-research'
import { analyticsTranslations } from './analytics'

export const static_translation = {
  ...analyticsTranslations.Hindi,
    "audience_access_available_audiences": "उपलब्ध दर्शक वर्ग",
    "audience_access_hcp": "स्वास्थ्य पेशेवरों के लिए उपलब्ध",
    "audience_access_partner": "पार्टनर्स के लिए उपलब्ध",
    "audience_access_staff_us": "अमेरिकी स्टाफ के लिए उपलब्ध",
    "audience_access_staff_global": "वैश्विक स्टाफ के लिए उपलब्ध",
  "upload_success": "अपलोड सफलतापूर्वक भेजा गया। स्वीकृति की प्रतीक्षा है।",
  "context": 'प्रसंग',
  "upload_title": "सामग्री अपलोड अनुरोध फ़ॉर्म",
  "mvu_essentials_register_welcome": "Welcome to MagVenture Universe Lite",
  "mvu_essentials_register_access_notice": "Access with this code is limited to a specific number of people. Thank you for not sharing it.",
  "portal_registration_participant_limit_reached": "इस एक्सेस के लिए प्रतिभागियों की अधिकतम संख्या पूरी हो चुकी है, इसलिए रजिस्ट्रेशन उपलब्ध नहीं है। सहायता के लिए अपने MagVenture एक्सेस के प्रभारी व्यक्ति से संपर्क करें।",
  "portal_registration_invite_invalid": "यह आमंत्रण लिंक अमान्य है या इसकी समय-सीमा समाप्त हो चुकी है।",
  "lite_registration_success_title": "रजिस्ट्रेशन पूरा हुआ",
  "lite_registration_success_email_text": "MagVenture Universe Lite के लिए आपका एक्सेस तैयार है। हमने एक्सेस लिंक के साथ स्वागत ई-मेल भेजा है। अभी रजिस्टर किए गए ई-मेल और पासवर्ड से लॉगिन करें।",
  "lite_registration_success_text": "MagVenture Universe Lite के लिए आपका एक्सेस तैयार है। अभी रजिस्टर किए गए ई-मेल और पासवर्ड से लॉगिन करें।",
  "lite_registration_success_action": "Lite लॉगिन पर जाएँ",
  "accelerator_registration_success_title": "रजिस्ट्रेशन पूरा हुआ",
  "accelerator_registration_success_email_text": "MagVenture Accelerator Program के लिए आपका एक्सेस तैयार है। हमने एक्सेस लिंक के साथ स्वागत ई-मेल भेजा है। अभी रजिस्टर किए गए ई-मेल और पासवर्ड से लॉगिन करें।",
  "accelerator_registration_success_text": "MagVenture Accelerator Program के लिए आपका एक्सेस तैयार है। अभी रजिस्टर किए गए ई-मेल और पासवर्ड से लॉगिन करें।",
  "accelerator_registration_success_action": "Accelerator लॉगिन पर जाएँ",
  "describe_as_upload": "नीचे दी गई जानकारी भरें और वे फ़ाइलें अपलोड करें जिन्हें आप MagVenture Universe पर अपलोड करने के लिए नए कंटेंट के तौर पर प्रपोज़ करना चाहते हैं। कुछ दिनों में, हमारी सपोर्ट टीम आपकी रिक्वेस्ट के बारे में और जानकारी के साथ आपसे संपर्क करेगी।",
  "title": "शीर्षक",
  "table": "सामग्री प्रकार",
  "tags": "टैग",
  "tag-types": "टैग प्रकार",
  "categories": "श्रेणियाँ",
  "sub-categories": "उप-श्रेणियाँ",
  "document": "दस्तावेज़",
  "image": "छवि",

  "cancel": "रद्द करें",
  "send": "भेजें",
  'share_link': 'लिंक साझा करें',
  'share_link_description': 'इस लिंक के साथ कोई भी व्यक्ति {days} दिनों तक इस सामग्री तक पहुँच सकता है। इसे सुरक्षित रूप से कॉपी और साझा करें।',
  'share_link_label': 'इस लिंक को साझा करें:',
  'copy_link': 'लिंक कॉपी करें',
  'copied': 'कॉपी हो गया!',
  'share_link_warning': 'यह लिंक {days} दिनों में समाप्त हो जाएगा।',
  'share_link_duration': 'वैधता (दिन)',
  'copy': 'कॉपी करें',
  "term_title": "कुकीज़ और गोपनीयता विवरण",
  "register": "रजिस्टर करें",
  "login": "लॉगिन",
  "email": "ई-मेल",
  "registration_professional_email_hint": "कृपया अपना पेशेवर ई-मेल इस्तेमाल करें, जैसे name@yourclinic.com।",
  "password": "पासवर्ड",
  "signin": "लॉगिन",
  "session_expired_sign_in_again": "आपका सत्र समाप्त हो गया है। जारी रखने के लिए कृपया फिर से साइन इन करें।",
  "reset_password": "पासवर्ड रीसेट करें",
  "fill_the_field": "कृपया यह फ़ील्ड भरें",
  "success": "धन्यवाद!",
  "onboarding": "ऑनबोर्डिंग वीडियो",
  "account_successfully_created": "हमारी टीम आपके अनुरोध की समीक्षा करेगी और यदि अतिरिक्त जानकारी की आवश्यकता होगी तो आपसे संपर्क करेगी। आपका खाता स्वीकृत होकर उपयोग के लिए तैयार होने पर आपको ई-मेल प्राप्त होगा।",
  "close": "बंद करें",
  "salutation": "सम्बोधन",
  "first_name": "पहला नाम",
  "last_name": "अंतिम नाम",
  "company_name": "कंपनी का नाम",
  "job_title": "पद / स्थिति",
  "industry": "कार्य क्षेत्र",
  "state": "राज्य / प्रांत",
  "zipcode": "पिन कोड",
  "phone_number": "फ़ोन नंबर",
  "password_confirmation": "पासवर्ड की पुष्टि",
  "mr": "श्री",
  "mrs": "श्रीमती",
  "ms": "सुश्री",
  "signup": "साइन अप करें",
  "are_you_a_patient_or_a_therapist": "क्या आप रोगी हैं या चिकित्सक?",
  "create_your_password": "अपना पासवर्ड बनाएँ",
  "finish": "समाप्त करें",
  "create_your_account": "अपना खाता बनाएँ",
  "back": "वापस",
  "next": "आगे",
  "create_a_password": "एक पासवर्ड बनाएँ",
  "enter_a_password_for_your_account": "अपने खाते के लिए पासवर्ड दर्ज करें",
  "subscribe_to_newsletter": "हां, मैं मैगवेंचर से शैक्षिक अपडेट, टीएमएस संसाधन और इवेंट की जानकारी प्राप्त करना चाहूंगा/चाहूंगी।",
  "subscribe_to_newsletter_information": "आप किसी भी समय सदस्यता रद्द कर सकते हैं। हम आपके व्यावसायिक इनबॉक्स का सम्मान करते हैं और केवल प्रासंगिक सामग्री ही साझा करते हैं।",
  "i_accept_the": "मैं सहमत हूँ",
  "i_accept_the_united": "यूएस गोपनीयता नीति",
  "privacy_policy": "गोपनीयता नीति",
  "send": "भेजें",
  "back_to_login": "लॉगिन पर वापस जाएँ",
  "enter_your_email_to_recover_your_password": "अपना पासवर्ड पुनर्प्राप्त करने के लिए अपना ई-मेल दर्ज करें",
  "access_the_recovery_link_that_was_sent_to_your_email": "अपने ई-मेल पर भेजे गए पुनर्प्राप्ति लिंक पर जाएँ",
  "check_your_email": "कृपया अपना ई-मेल जाँचें",
  "new_password": "नया पासवर्ड",
  "confirm_new_password": "नए पासवर्ड की पुष्टि करें",
  "new_password_and_new_password_confirmation_are_not_the_same": "नया पासवर्ड और उसकी पुष्टि एक जैसे नहीं हैं",
  "password_changed_successfully": "पासवर्ड सफलतापूर्वक बदल दिया गया!",
  "create_a_new_password": "नया पासवर्ड बनाएँ",
  "enter_a_new_password_for_your_account": "अपने खाते के लिए नया पासवर्ड दर्ज करें",
  "save": "सहेजें",
  "one_uppercase_letter": "कम से कम एक बड़े अक्षर का उपयोग करें",
  "one_number": "कम से कम एक संख्या का उपयोग करें",
  "at_least_6_characters": "कम से कम 6 अक्षर",
  "at_least_1_special_character": "कम से कम 1 विशेष चिन्ह",
  "accept_terms": "नियमों को स्वीकार करें",
  "password_and_password_confirmation_must_match": "पासवर्ड और पुष्टि एक समान होना चाहिए",
  "see_all": "सभी देखें",
  "watch_live_now": "अभी लाइव देखें",
  "courses_available_for_you": "आपके लिए उपलब्ध प्रोग्राम",
  "partners-and-staffs_available_for_you": "आपके लिए उपलब्ध Partners and Staff सामग्री",
  "product-information_available_for_you": "आपके लिए उपलब्ध उत्पाद जानकारी",
  "articles_available_for_you": "आपके लिए उपलब्ध लेख",
  "podcasts_available_for_you": "आपके लिए उपलब्ध पॉडकास्ट",
  "documents_available_for_you": "आपके लिए उपलब्ध दस्तावेज़",

  "support-materials_available_for_you": "आपके लिए उपलब्ध प्रैक्टिस सपोर्ट सामग्री",
  "marketing-materials_available_for_you": "आपके लिए उपलब्ध प्रैक्टिस मार्केटिंग सामग्री",
  "service-supports_available_for_you": "आपके लिए उपलब्ध Service & Support सामग्री",
  "product-informations_available_for_you": "आपके लिए उपलब्ध प्रैक्टिस उत्पाद जानकारी",
  "media-templates_available_for_you": "आपके लिए उपलब्ध सोशल मीडिया टेम्पलेट्स",
  "videos_available_for_you": "आपके लिए उपलब्ध वीडियो",
  "photos_available_for_you": "आपके लिए उपलब्ध फ़ोटो",

  "courses": "प्रशिक्षण और सीखना",
  "partners-and-staffs": "Partners and Staff",
  "product-information": "उत्पाद जानकारी",
  "articles": "लेख",
  "podcasts": "पॉडकास्ट",
  "documents": "दस्तावेज़",
  "home": "होम",
  "favorites": "पसंदीदा",
  "no_favorites_message": "आपने अभी तक कोई पसंदीदा नहीं जोड़ा है।",
  "faq": "सामान्य प्रश्न",
  "no_faqs_available": "कोई सामान्य प्रश्न उपलब्ध नहीं हैं।",
  "support": "सहायता",
  "contact_us": "हमसे संपर्क करें",
  "my_account": "मेरा खाता",
  "my_certificates": "मेरे सर्टिफिकेट",
  "logout": "लॉगआउट",
  "search": "खोजें",
  "frequently_asked_questions": "अक्सर पूछे जाने वाले प्रश्न",
  "how_can_we_help_you": "हम आपकी कैसे मदद कर सकते हैं?",
  "add_new_ticket": "सहायता अनुरोध बनाएँ",
  "all_tickets": "सभी अनुरोध",
  "pending": "लंबित",
  "closed_tickets": "बंद अनुरोध",
  "videos_and_contents": "वीडियो और सामग्री",
  "ticket_information": "अनुरोध की जानकारी",
  "add_reply": "उत्तर जोड़ें",
  "close_ticket": "अनुरोध बंद करें",
  "status": "स्थिति",
  "ticket_id": "अनुरोध आईडी",
  "created_date": "बनाने की तारीख",
  "category_department": "श्रेणी/विभाग",
  "give_feedback": "प्रतिक्रिया दें",
  "how_would_you_rate_the_way_this_request_was_handled": "आप इस अनुरोध के निपटारे को कैसे रेट करेंगे?",
  "subject": "विषय",
  "area_departament": "क्षेत्र / विभाग",
  "message": "संदेश",
  "create_a_new_ticket": "नया अनुरोध बनाएँ",
  "describe_as_soon_as_possible": "कृपया अपना समस्या विवरण लिखें और उपयुक्त विभाग चुनें ताकि हमारी टीम आपको जल्द से जल्द सहायता दे सके।",
  "no_records_found": "कोई रिकॉर्ड नहीं मिला",
  "showing": "दिखा रहे हैं",
  "of": "में से",
  "results": "परिणाम",
  "subject_title": "विषय/शीर्षक",
  "last_updated": "अंतिम अद्यतन",
  "cancel": "रद्द करें",
  "registration_data": "पंजीकरण डेटा",
  "updated_successfully": "सफलतापूर्वक अद्यतन किया गया",
  "created_successfully": "सफलतापूर्वक बनाया गया",
  "edit": "संपादित करें",
  "done": "समाप्त",
  "filters": "फ़िल्टर",
  "search.sections.trainingLearning": "प्रशिक्षण और सीखना",
  "search.sections.documents": "दस्तावेज़",
  "search.sections.images": "छवियाँ",
  "category": "श्रेणी",
  "filter": "फ़िल्टर",
  "clear": "साफ़ करें",
  "support_materials": "प्रैक्टिस सपोर्ट सामग्री",
  "marketing_materials": "प्रैक्टिस मार्केटिंग सामग्री",
  "media_templates": "सोशल मीडिया टेम्पलेट्स",
  "videos": "वीडियो",
  "photos": "फ़ोटो",
  "support-materials": "प्रैक्टिस सपोर्ट सामग्री",
  "marketing-materials": "मार्केटिंग सामग्री",
    "sales-support-materials": "Sales Support Materials",
    "sales-support-materials_available_for_you": "Sales Support Materials available for you",
    "sales_support_materials_empty": "No sales support materials are available yet.",
    "sales_support_materials_error": "We could not load the sales support materials. Please try again.",
    "sales_support_materials_unavailable": "Sales support materials are temporarily unavailable",
  "service-supports": "Service & Support",
  "service_support": "Service & Support",
  "support_videos": "Support Videos",
  "support_videos_empty": "अभी कोई सहायता वीडियो उपलब्ध नहीं है।",
  "support_videos_unavailable": "सहायता वीडियो उपलब्ध नहीं हैं",
  "support_videos_error": "सहायता वीडियो लोड नहीं हो सके। कृपया फिर से प्रयास करें।",
  "support_video_unavailable": "सहायता वीडियो उपलब्ध नहीं है",
  "support_video_media_missing": "वीडियो उपलब्ध नहीं है",
  "support_video_media_missing_description": "इस सहायता वीडियो के लिए अभी चलाने योग्य मीडिया उपलब्ध नहीं है।",
  "support_video_about": "इस वीडियो के बारे में",
  "product-informations": "उत्पाद जानकारी",
  "media-templates": "सोशल मीडिया टेम्पलेट्स",
  "login_title": "कृपया लॉगिन करें",
  "login_title_essentials": "कृपया MagVenture Universe Lite में लॉगिन करें",
  "accelerator_brand_name": "MagVenture",
  "accelerator_brand_program": "Accelerator Program",
  "login_title_accelerator": "Welcome to the MagVenture Accelerator Portal",
  "accelerator_welcome_intro": "This is your exclusive portal for everything you need to prepare for and participate in the MagVenture Accelerator.",
  "accelerator_welcome_details": "Here you’ll find clinical training focused specifically on Introduction to TMS, Major Depressive Disorder (MDD), and Obsessive Compulsive Disorder (OCD), along with materials and resources from the Accelerator program which will be posted after the program.",
  "accelerator_welcome_login": "Log in to access your training and Accelerator resources.",
  "welcome": "स्वागत है! यह आपका विशेष पोर्टल है जहाँ आपको क्लिनिकल प्रशिक्षण, प्रैक्टिस मार्केटिंग सामग्री और मीडिया संसाधन मिलते हैं — जिनमें वीडियो, उपचार फ़ोटो और सोशल मीडिया टेम्पलेट्स शामिल हैं। MagVenture के साथ सफलता में सहायता करने वाले टूल्स तक पहुँचने के लिए लॉगिन करें।",
  "existing_users": "मौजूदा उपयोगकर्ता",
  "enter_credentials_to_continue": "जहाँ से आपने छोड़ा था वहाँ से जारी रखने के लिए लॉगिन जानकारी दर्ज करें।",
  "new_users": "नए उपयोगकर्ता",
  "register_link_text": "रजिस्टर करें",
  "register_and_gain_access_part1": "खाता चाहिए? जाएँ ",
  "register_and_gain_access_part2": " और हमारे विशेष सीखने और संसाधन प्लेटफ़ॉर्म तक पूर्ण पहुँच प्राप्त करें।",
  "contact": "हमसे संपर्क करें",
  "contact.topicCategory": "विषय श्रेणी चुनें",
  "contact.topicCategory.label": "विषय श्रेणी",
  "contact.chooseSubject": "अपनी अनुरोध के लिए सबसे उपयुक्त विषय चुनें।",
  "contact.message": "संदेश",
  "contact.message.label": "संदेश",
  "contact.describeIssue": "कृपया अपनी समस्या का विस्तृत विवरण दें। हमारी टीम यथाशीघ्र उत्तर देगी।",
  "contact.fileAttachment": "फ़ाइल संलग्न करें",
  "contact.fileAttachment.label": "फ़ाइल संलग्नक",
  "contact.attachmentHelp": "आप वैकल्पिक रूप से अपने अनुरोध से संबंधित स्क्रीनशॉट या फ़ाइल संलग्न कर सकते हैं (जैसे JPG, PNG, PDF, DOC)।",
  "contact.preferredContact": "पसंदीदा संपर्क विधि",
  "contact.preferredContact.label": "पसंदीदा संपर्क विधि",
  "contact.contactPreference": "इस समस्या के बारे में आप किस प्रकार संपर्क करना पसंद करेंगे?",
  "contact.maximum_characters": "अधिकतम: 1000 अक्षर",
  "contact.email.label": "ई-मेल",
  "contact.phone.label": "फ़ोन",
  "contact.technical_support": "MagVenture Universe सामग्री के बारे में प्रश्न",
  "contact.video_streaming": "वीडियो स्ट्रीमिंग समस्या",
  "contact.questions_about_products": "MagVenture उत्पाद/सेवाओं के बारे में प्रश्न",
  "contact.material_download": "सामग्री डाउनलोड समस्या",
  "contact.suggestion": "सुझाव",
  "contact.other": "अन्य",
  "contact.file": "फ़ाइलें चुनें",
  "contact.submit": "सबमिट करें",
  "contact.is_required": "अनिवार्य है",
  "contact.success": "संपर्क सफलतापूर्वक भेजा गया",
  "register.undertems": "MagVenture Universe तक पहुँच समीक्षा और स्वीकृति के अधीन है। पंजीकरण अनुरोधों को स्वीकृत होने में अधिकतम 2 कार्य दिवस लग सकते हैं।",
  "courses-webnars-trainning": "कोर्स, वेबिनार और प्रशिक्षण",
  "usshop": "यूएस शॉप",
  "chat": "चैट एजेंट",
  "country": "देश",
  "verify_email": "ई-मेल सत्यापित करें",
  "enter_the_code_sent_to_your_email": "अपने ई-मेल पर भेजा गया कोड दर्ज करें",
  "we_sent_a_code_to_email": "हमने इस पते पर सत्यापन कोड भेजा है:",
  "enter_verification_code": "सत्यापन कोड दर्ज करें",
  "code_expires_in": "कोड की वैधता खत्म होने में",
  "verify": "सत्यापित करें",
  "resend_code_in": "कोड पुनः भेजने का विकल्प उपलब्ध होगा",
  "resend_code": "कोड पुनः भेजें",
  "a_new_code_has_been_sent": "एक नया कोड भेजा गया है।",
  "please_confirm_you_are_not_a_robot": "कृपया पुष्टि करें कि आप रोबोट नहीं हैं।",
  "email_verified_successfully": "ई-मेल सफलतापूर्वक सत्यापित हो गया।",
  "continue": "जारी रखें",
  "notifications": "सूचनाएँ",
  "unread_notifications": "अपठित सूचनाएँ",
  "unread_notification": "अपठित सूचना",
  "unread": "अपठित",
  "mark_all_notifications_read": "सभी को पढ़ा हुआ चिह्नित करें",
  "notifications_update_error": "सूचनाएँ अपडेट नहीं की जा सकीं।",
  "try_again": "फिर से प्रयास करें",
  "notifications_load_error": "सूचनाएँ लोड नहीं की जा सकीं",
  "notifications_load_error_description": "अपना कनेक्शन जाँचें और फिर से प्रयास करें।",
  "notifications_empty": "अभी कोई सूचना नहीं है",
  "notifications_empty_description": "अपडेट और महत्वपूर्ण गतिविधियाँ यहाँ दिखाई देंगी।",
  "notification_not_found": "सूचना नहीं मिली",
  "notification_not_found_description": "यह सूचना अब उपलब्ध नहीं है या आपके पास इसकी पहुँच नहीं है।",
  "back_to_notifications": "सूचनाओं पर वापस जाएँ",
  "open_notification": "खोलें",
  "loading_notifications": "सूचनाएँ लोड हो रही हैं",
  "loading_notification": "सूचना लोड हो रही है",
  "notifications_subtitle": "अपडेट, नए कोर्स और महत्वपूर्ण गतिविधियाँ एक ही स्थान पर देखें।",
  "recent_activity": "हाल की गतिविधि",
  "notifications_all_read": "सभी सूचनाएँ पढ़ी गई हैं",
  "staff_essentials_invites_title_required": "शीर्षक आवश्यक है।",
  "staff_essentials_invites_updated": "आमंत्रण अपडेट किया गया।",
  "staff_essentials_invites_created": "आमंत्रण बनाया गया।",
  "staff_essentials_invites_link_unavailable": "आमंत्रण लिंक उपलब्ध नहीं है।",
  "staff_essentials_invites_link_copied": "आमंत्रण लिंक कॉपी किया गया।",
  "staff_essentials_invites_copy_prompt": "इस आमंत्रण लिंक को कॉपी करें:",
  "staff_essentials_invites_eyebrow": "MagVenture Universe",
  "staff_essentials_invites_menu_title": "MVU Lite Invitations",
  "staff_essentials_invites_title": "MVU Lite Invitations",
  "staff_essentials_invites_subtitle": "MagVenture Universe Lite के आमंत्रण लिंक बनाएँ और देखें कि हर लिंक से कितने पंजीकरण हुए हैं।",
  "staff_essentials_invites_refresh": "रीफ्रेश",
  "staff_essentials_invites_create": "आमंत्रण बनाएँ",
  "staff_essentials_invites_total": "कुल आमंत्रण",
  "staff_essentials_invites_active": "सक्रिय",
  "staff_essentials_invites_registrations": "पंजीकरण",
  "staff_essentials_invites_remaining": "शेष",
  "staff_essentials_invites_links": "आमंत्रण लिंक",
  "staff_essentials_invites_found_singular": "आमंत्रण मिला",
  "staff_essentials_invites_found_plural": "आमंत्रण मिले",
  "staff_essentials_invites_none_created": "अभी कोई आमंत्रण लिंक नहीं बनाया गया",
  "staff_essentials_invites_syncing": "सिंक हो रहा है",
  "staff_essentials_invites_live_data": "लाइव डेटा",
  "staff_essentials_invites_loading_links": "आमंत्रण लिंक लोड हो रहे हैं...",
  "staff_essentials_invites_column_title": "शीर्षक",
  "staff_essentials_invites_column_link": "लिंक",
  "staff_essentials_invites_column_status": "स्थिति",
  "staff_essentials_invites_column_used": "उपयोग",
  "staff_essentials_invites_column_remaining": "शेष",
  "staff_essentials_invites_column_expires": "समाप्ति",
  "staff_essentials_invites_column_created": "बनाया गया",
  "staff_essentials_invites_column_actions": "कार्रवाई",
  "staff_essentials_invites_active_status": "सक्रिय",
  "staff_essentials_invites_inactive_status": "निष्क्रिय",
  "staff_essentials_invites_unlimited": "असीमित",
  "staff_essentials_invites_copy_link": "लिंक कॉपी करें",
  "staff_essentials_invites_history": "इतिहास",
  "staff_essentials_invites_edit": "संपादित करें",
  "staff_essentials_invites_empty_title": "अभी कोई Lite आमंत्रण नहीं",
  "staff_essentials_invites_empty_description": "पंजीकरण ट्रैक करना शुरू करने के लिए पहला आमंत्रण लिंक बनाएँ।",
  "staff_essentials_invites_edit_modal": "आमंत्रण संपादित करें",
  "staff_essentials_invites_create_modal": "आमंत्रण बनाएँ",
  "staff_essentials_invites_generated_by_strapi": "आमंत्रण कोड और सार्वजनिक लिंक Strapi द्वारा बनाए जाते हैं।",
  "staff_essentials_invites_field_title": "शीर्षक",
  "staff_essentials_invites_field_maximum_uses": "No. of users having access to this invitation",
  "staff_essentials_invites_field_expires_at": "समाप्ति समय",
  "staff_essentials_invites_history_modal": "आमंत्रण इतिहास",
  "staff_essentials_invites_loading_history": "इतिहास लोड हो रहा है...",
  "staff_essentials_invites_no_institution": "कोई संस्था नहीं",
  "staff_essentials_invites_no_registrations": "इस आमंत्रण के लिए अभी कोई पंजीकरण नहीं है।",
  "staff_essentials_invites_locked_content_title": "सामग्री एक्सेस",
  "lite_invite_default_content_help": "Lite के लिए कॉन्फ़िगर की गई सभी सामग्री डिफ़ॉल्ट रूप से उपलब्ध है। एक्सेस को बदलने के लिए उन्नत विकल्पों का उपयोग करें।",
  "staff_essentials_invites_locked_content_description": "चयनित सामग्री इस आमंत्रण से पंजीकृत उपयोगकर्ताओं के लिए उपलब्ध है। एक्सेस ब्लॉक करने के लिए किसी आइटम का चयन हटाएँ।",
  "staff_essentials_invites_locked_content_selected": "एक्सेस के साथ",
  "staff_essentials_invites_locked_content_select_visible": "दिखाई देने वाले परिणामों की अनुमति दें",
  "staff_essentials_invites_locked_content_clear": "सभी सामग्री लॉक करें",
  "staff_essentials_invites_locked_content_search": "Search Lite content",
  "staff_essentials_invites_locked_content_filter": "Content type",
  "staff_essentials_invites_locked_content_all_types": "All types",
  "staff_essentials_invites_locked_content_loading": "Loading catalog...",
  "staff_essentials_invites_locked_content_empty": "No matching content.",
  "staff_essentials_invites_locked_content_error": "Could not load the Lite catalog.",
  "staff_essentials_invites_content_preset_title": "कंटेंट प्रीसेट",
  "staff_essentials_invites_content_preset_description": "वर्तमान चयन को समूहों की संयुक्त सामग्री से बदलने के लिए एक या अधिक समूह चुनें। फिर नीचे दिए गए आइटम अपनी आवश्यकता के अनुसार बदलें।",
  "staff_essentials_invites_content_preset_placeholder": "पूर्वनिर्धारित कंटेंट समूह",
  "staff_essentials_invites_content_preset_custom": "कस्टम चयन (कोई प्रीसेट नहीं)",
  "staff_essentials_invites_content_preset_loading": "कंटेंट प्रीसेट लोड हो रहे हैं...",
  "staff_essentials_invites_content_preset_error": "कंटेंट प्रीसेट लोड नहीं हो सके।",
  "staff_essentials_invites_content_preset_empty": "कोई सक्रिय प्रीसेट उपलब्ध नहीं है। आप कंटेंट मैन्युअली चुन सकते हैं।",
  "staff_essentials_invites_content_preset_applied": "प्रीसेट लागू किया गया",
  "staff_essentials_invites_content_preset_applied_description": "यह कंटेंट आमंत्रण में कॉपी किया गया है। नीचे किए गए बदलाव Strapi समूह को नहीं बदलेंगे।",
  "exclusive_content_title": "Exclusive content",
  "exclusive_content_message": "This content is exclusive to MagVenture clients.",
  "survey_load_error": "यह सर्वेक्षण लोड नहीं हो सका।",
  "survey_unavailable": "सर्वेक्षण उपलब्ध नहीं है",
  "survey_back_to_course": "पाठ्यक्रम पर वापस जाएँ",
  "survey_thank_you": "आपकी प्रतिक्रिया के लिए धन्यवाद",
  "survey_completed_description": "आपके उत्तर सहेज लिए गए हैं। आप पाठ्यक्रम जारी रख सकते हैं।",
  "survey_submitted": "जमा किया गया",
  "survey_continue_course": "पाठ्यक्रम जारी रखें",
  "survey_course_feedback": "पाठ्यक्रम प्रतिक्रिया",
  "survey_intro_description": "अपने प्रशिक्षण अनुभव के बारे में निम्नलिखित प्रश्नों के उत्तर दें।",
  "survey_questions": "प्रश्न",
  "survey_minutes": "मिनट",
  "survey_account_linked": "आपके खाते में सहेजा गया",
  "survey_start": "सर्वेक्षण शुरू करें",
  "survey_progress": "सर्वेक्षण प्रगति",
  "survey_optional": "वैकल्पिक",
  "survey_required": "आवश्यक",
  "survey_text_placeholder": "अपना उत्तर यहाँ लिखें...",
  "survey_back": "वापस",
  "survey_submit": "प्रतिक्रिया जमा करें",
  "survey_continue": "जारी रखें",
  "survey_required_answer": "यह प्रश्न आवश्यक है।",
  "survey_required_before_quiz": "इस क्विज़ को शुरू करने से पहले आवश्यक सर्वेक्षण पूरा करें।",
  "survey_required_title": "सर्वेक्षण आवश्यक है",
  "survey_open": "सर्वेक्षण खोलें",
  "survey_completed_action": "सर्वेक्षण पूरा हुआ",
  "survey_complete_required": "आवश्यक सर्वेक्षण पूरा करें",
  "survey_course_completed": "कोर्स पूरा हुआ",
  "survey_next_step": "अगला चरण",
  "survey_share_experience": "अपना अनुभव साझा करें",
  "survey_opens_in": "सर्वेक्षण खुलने में",
  "survey_seconds": "सेकंड",
  "survey_answer_now": "सर्वेक्षण भरें",
  "survey_stay_here": "यहीं रहें",
  "user_approvals_menu_title": "उपयोगकर्ता अनुमोदन",
  "user_approvals_eyebrow": "पहुँच प्रबंधन",
  "user_approvals_title": "उपयोगकर्ता अनुमोदन",
  "user_approvals_subtitle": "अपने अनुमोदन क्षेत्र की लंबित पहुँच अनुरोधों की समीक्षा करें।",
  "user_approvals_pending_count": "लंबित",
  "user_approvals_refresh": "रीफ़्रेश",
  "user_approvals_pending_requests": "लंबित अनुरोध",
  "user_approvals_search_placeholder": "नाम, ईमेल या कंपनी से खोजें",
  "user_approvals_unavailable": "अनुमोदन उपलब्ध नहीं हैं",
  "user_approvals_auth_required": "अनुरोध देखने के लिए साइन इन करें।",
  "user_approvals_not_authorized": "इस खाते से कोई सक्रिय अनुमोदन प्राप्तकर्ता जुड़ा नहीं है।",
  "user_approvals_network_error": "नेटवर्क त्रुटि। फिर से प्रयास करें।",
  "user_approvals_load_error": "अनुमोदन अनुरोध लोड नहीं हो सके।",
  "user_approvals_empty": "कोई लंबित अनुमोदन नहीं है।",
  "user_approvals_empty_description": "आपके क्षेत्र के नए अनुरोध यहाँ दिखाई देंगे।",
  "user_approvals_no_search_results": "कोई मिलते-जुलते अनुमोदन नहीं",
  "user_approvals_no_search_results_description": "दूसरा नाम, ईमेल या कंपनी आज़माएँ।",
  "user_approvals_created_at": "बनाया गया",
  "user_approvals_name": "नाम",
  "user_approvals_email": "ईमेल",
  "user_approvals_company": "कंपनी",
  "user_approvals_country": "देश",
  "user_approvals_region": "क्षेत्र",
  "user_approvals_location": "स्थान",
  "user_approvals_status": "स्थिति",
  "user_approvals_actions": "कार्रवाइयाँ",
  "user_approvals_approved": "स्वीकृत",
  "user_approvals_rejected": "अस्वीकृत",
  "user_approvals_approve": "स्वीकार करें",
  "user_approvals_reject": "अस्वीकार करें",
  "user_approvals_already_processed": "यह अनुमोदन अनुरोध पहले ही संसाधित हो चुका है।",
  "user_approvals_process_error": "इस अनुमोदन अनुरोध को संसाधित नहीं किया जा सका।",
  "user_approvals_approve_success": "उपयोगकर्ता सफलतापूर्वक स्वीकृत हुआ।",
  "user_approvals_reject_success": "उपयोगकर्ता सफलतापूर्वक अस्वीकृत हुआ।",
  "user_approvals_manual_review_required": "मैन्युअल समीक्षा आवश्यक",
  "user_approvals_company_informed": "पंजीकरण में दी गई कंपनी",
  "user_approvals_phone": "फ़ोन",
  "user_approvals_customer_select": "ग्राहक / क्लिनिक",
  "user_approvals_search_companies": "ग्राहक या क्लिनिक खोजें",
  "user_approvals_no_companies": "कोई मेल खाता ग्राहक या क्लिनिक नहीं मिला",
  "user_approvals_company_load_error": "ग्राहक या क्लिनिक विकल्प लोड नहीं हो सके।",
  "user_approvals_confirm_title": "उपयोगकर्ता स्वीकृत करें",
  "user_approvals_confirm_description": "पंजीकरण की समीक्षा करें और पहुँच स्वीकृत करने से पहले ग्राहक संबंध की पुष्टि करें।",
  "user_approvals_association_confirmation": "यह उपयोगकर्ता इससे संबद्ध होगा:",
  "user_approvals_confirm_approval": "स्वीकृति की पुष्टि करें",
  "mag.title": "Maggie",
  "mag.subtitle": "Your learning companion",
  "mag.preview_badge": "Preview",
  "mag.open_aria": "Open Maggie assistant",
  "mag.close_aria": "Close Maggie assistant",
  "mag.launcher_tooltip": "Talk to Maggie",
  "mag.intro_title": "Hi! I'm Maggie.",
  "mag.intro_body": "How can I help?",
  "mag.dismiss_intro_aria": "Dismiss Maggie introduction",
    "mag.welcome": "नमस्ते! मैं Maggie हूँ। आज आप क्या जानना चाहेंगे?",
    "mag.welcome_named": "नमस्ते, {name}! मैं Maggie हूँ। आज आप क्या जानना चाहेंगे?",
  "mag.quick_actions_label": "Try asking",
  "mag.quick.find_course": "Find a course",
  "mag.quick.explore_trails": "Explore Learning Paths",
  "mag.quick.continue_learning": "Continue learning",
  "mag.quick.product_tutorials": "Find product tutorials",
  "mag.quick.about_magventure": "Learn how MagVenture works",
  "mag.placeholder": "Ask Maggie a question...",
  "mag.composer_label": "Message to Maggie",
  "mag.send_aria": "Send message to Maggie",
  "mag.preview_response": "मैं MagVenture की शिक्षण लाइब्रेरी से उत्तर दे सकता हूँ।",
  "mag.local_error": "Maggie उत्तर तैयार नहीं कर सकी। कृपया फिर से प्रयास करें।",
  "mag.typing": "Maggie उत्तर तैयार कर रही है",
  "mag.you_label": "Your message",
  "mag.mag_label": "Message from Maggie",
  "mag.avatar_fallback": "Maggie avatar fallback",
  "mag.loading": "Opening Maggie...",
    "mag.sources": "स्रोत",
    "mag.page": "पृष्ठ",
  "mag.feedback_question": "क्या यह उपयोगी था?",
  "mag.feedback_up": "उपयोगी उत्तर",
  "mag.feedback_down": "अनुपयोगी उत्तर",
  "mag.feedback_thanks": "आपकी प्रतिक्रिया के लिए धन्यवाद।",
  "mag.feedback_error": "प्रतिक्रिया भेजी नहीं जा सकी।",
    "mag.feedback_form.title": "फ़ीडबैक साझा करें",
    "mag.feedback_form.open": "फ़ीडबैक साझा करने के लिए यहाँ क्लिक करें",
    "staff_essentials_invites_content_locked": "लॉक किया गया",
    "staff_essentials_invites_content_available": "एक्सेस दिया गया",
    "mag.feedback_form.description": "Your feedback will be saved in our internal inbox for the MagVenture team to review. Up to 4,000 characters.",
    "mag.feedback_form.placeholder": "Your feedback",
    "mag.feedback_form.submit": "Submit feedback",
    "mag.feedback_form.cancel": "Back to chat",
    "mag.competitor_feedback.prompt": "नमस्ते! मैं Competitive Hub को समझने में आपकी मदद कर सकती हूँ। आप क्या जानना चाहेंगे? सुझाव भेजने के लिए नीचे दिए गए फ़ीडबैक बटन का उपयोग करें।",
    "mag.competitor_feedback.prompt_named": "नमस्ते, {name}! मैं Competitive Hub को समझने में आपकी मदद कर सकती हूँ। आप क्या जानना चाहेंगे? सुझाव भेजने के लिए नीचे दिए गए फ़ीडबैक बटन का उपयोग करें।",
  "mag.competitor_feedback.placeholder": "Share your Competitor Hub feedback...",
    "mag.competitor_feedback.success": "Thank you! Your feedback has been saved for our team to review.",
    "mag.competitor_feedback.error": "Your feedback could not be saved. Your message is still in the form; please try again.",
  "mag.feedback_reason.not_helpful": "उपयोगी नहीं",
  "mag.feedback_reason.wrong_source": "गलत स्रोत",
  "mag.feedback_reason.unclear": "अस्पष्ट",
  "mag.feedback_reason.too_general": "बहुत सामान्य",
  "mag.feedback_reason.unsafe": "असुरक्षित",
  "competitive_intelligence_menu_title": "प्रतिस्पर्धी इंटेलिजेंस",
  "competitive_intelligence_eyebrow": "बाज़ार इंटेलिजेंस",
  "competitive_intelligence_title": "प्रतिस्पर्धी इंटेलिजेंस",
  "competitive_intelligence_description": "MagVenture द्वारा ट्रैक किए गए प्रतिस्पर्धी शोध, बाज़ार संकेतों और सोशल स्रोतों का वर्तमान दृश्य।",
  "competitive_intelligence_freshness_unknown": "अपडेट समय उपलब्ध नहीं है",
  "competitive_intelligence_overview_heading": "इंटेलिजेंस अवलोकन",
  "competitive_intelligence_metric_competitors": "ट्रैक किए गए प्रतिस्पर्धी",
  "competitive_intelligence_metric_research": "शोध रिकॉर्ड",
  "competitive_intelligence_metric_market": "बाज़ार संकेत",
  "competitive_intelligence_metric_social": "सोशल पोस्ट",
  "competitive_intelligence_sources_title": "शोध स्रोत",
  "competitive_intelligence_sources_description": "वर्तमान प्रतिस्पर्धी इंटेलिजेंस डेटाबेस की कवरेज और ताज़गी।",
  "competitive_intelligence_records": "रिकॉर्ड",
  "competitive_intelligence_sources_empty": "स्रोत-स्तर का विवरण अभी उपलब्ध नहीं है।",
  "competitive_intelligence_loading": "प्रतिस्पर्धी इंटेलिजेंस अवलोकन लोड हो रहा है",
  "competitive_intelligence_empty_title": "अभी कोई इंटेलिजेंस डेटा नहीं है",
  "competitive_intelligence_empty_description": "डेटा पाइपलाइन ने अभी अवलोकन रिकॉर्ड प्रकाशित नहीं किए हैं।",
  "competitive_intelligence_denied_title": "एक्सेस उपलब्ध नहीं है",
  "competitive_intelligence_denied_description": "आपके खाते को प्रतिस्पर्धी इंटेलिजेंस का एक्सेस नहीं है।",
  "competitive_intelligence_unavailable_title": "प्रतिस्पर्धी इंटेलिजेंस उपलब्ध नहीं है",
  "competitive_intelligence_unavailable_description": "अभी सेवा से संपर्क नहीं हो पा रहा है। कृपया थोड़ी देर बाद फिर प्रयास करें।",
  "competitive_intelligence_error_title": "अवलोकन लोड नहीं हो सका",
  "competitive_intelligence_error_description": "एक अप्रत्याशित प्रतिक्रिया के कारण यह अवलोकन लोड नहीं हो सका।",
  ...competitiveIntelligenceResearchTranslations.Hindi
}
